import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
import { getPostLoginPath } from "../../utilities/postLoginRoute";

/**
 * RoleBasedRedirect component that redirects users to their appropriate
 * dashboard based on their role after successful authentication
 */
const RoleBasedRedirect = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  let userRole = user.user_type;

  if (!userRole && typeof user === "object") {
    const possibleRoleChars = Object.keys(user)
      .filter((key) => !isNaN(parseInt(key)))
      .sort((a, b) => parseInt(a) - parseInt(b))
      .map((key) => user[key]);

    if (possibleRoleChars.length > 0) {
      userRole = possibleRoleChars.join("");
    }
  }

  const path = getPostLoginPath(userRole);

  if (path === "/" && userRole) {
    console.warn("Unknown role:", userRole, user);
  }

  return <Navigate to={path} replace />;
};

export default RoleBasedRedirect;
